// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Suriname from '../_raw/flag/icon_flag_suriname.png';

export default () => <img src={Suriname} alt="Suriname" />;
